import React, { Component } from 'react';
import { Link } from 'react-router-dom'

import TimeUtils from '../services/TimeUtils.js'
import NumberUtils from '../services/NumberUtils.js'
import StringUtils from '../services/StringUtils.js'
import Player from '../services/player.js'
import Element from '../services/Element.js'
import MobileIdentifier from '../services/MobileIdentifier.js'

import '../../css/GridElement.css';

class GridElementInfo extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }
  }

  renderInfo() {
    let element = this.props.element;
    let type = this.props.type;

    let elementName = Element.name(type, element);
    let elementUrl = Element.url(type, element);

    let elementDetail = undefined;

    if (type === 'track') {
      elementDetail = <label className="detail">
      <Link className="clickable" to={Element.url('artist', element)}>{element.artist} </Link>
      { element.album && <Link className="clickable" to={Element.url('album', element)}>&nbsp;-&nbsp;{element.album}</Link> }
      </label>
    } else if (type === 'album') {
      elementDetail = <label className="detail"><Link className="clickable" to={Element.url('artist', element)}>{element.artist}</Link></label>
    }

    let thirdLine = undefined;

    let count = element.count;

    if (typeof(count) ==='number')
      thirdLine = `${NumberUtils.abbreviation(count)} ${StringUtils.inflect('play', count)}`;
    

    let fourthLine = undefined;

    if (element.when) {
      fourthLine = `Heard ${TimeUtils.getTimeAgo(element.when)}`;
    }

    let elementMainInfo = <Link className="clickable main" to={elementUrl}>{elementName}</Link>;

    return (
      <div className="info">
        { elementMainInfo }
        { elementDetail }
        { thirdLine && <label className="elementExtraInfo">{thirdLine}</label> }
        { fourthLine && <label className="elementExtraInfo">{fourthLine}</label> }
      </div>
    );

  }

  tourPage(url, evt) {
    evt.stopPropagation();
    evt.preventDefault();
    window.open(url, '_blank');
  }

  play(params, evt) {
    evt.stopPropagation();
    evt.preventDefault();
    Player.searchTracks(params);
  }

  playerElement(element) {
    return [element].map((element) => { 

      let newElement = {}; 

      Object.keys(element).forEach(function(key) {
       newElement[key] = element[key];
      }); 

      return newElement;

    })
    .map((element) => {
      delete element.img; 
      delete element.url;
      delete element.tour;
      delete element.when;
      delete element.count;
      return element;
    });
  }

  render() {

    let element = this.props.element;
    let type = this.props.type;

    let params = {type: type, terms: this.playerElement(element)};

    let style = {'backgroundImage': `url(${element.img})`};

    let imageShape = type === 'artist' ? 'rounded' : '';

    let isMobile = MobileIdentifier();

    return (

      <li className="gridItem">
        <Link to={Element.url(type, element)}>
          <div className={`clickable image ${imageShape}`} style={style}>
            <i onClick={this.play.bind(this, params)} className={`clickable playable icon-inner-play ${isMobile ? 'visible' : ''}`}></i>
            { element.tour && <label onClick={this.tourPage.bind(this, element.tour.uri)} className="clickable tour">TOUR</label>}
          </div>
        </Link>
        {this.renderInfo()}
      </li>
              
    ); 

  }
}

export default GridElementInfo;



// WEBPACK FOOTER //
// ./src/js/components/GridElement.jsx